import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';
import store from '@/store';
import {
  getUserNotifications,
  getUserTopNotifications,
  getCountNewUserNotifications,
  sendReadNotifications,
  markAllNotificationsRead,
} from '@/api/notifications';
import { StatementEntity } from '@/domains';

export interface INotification {
  id: string;
  statementId: string;
  statusCode: string;
  statusName: string;
  statusDescription: string;
  statusDate: string;
  isNew: boolean;
}

export interface INotificationSignatures {
  id: string;
  statusDate: string;
  statementType: StatementEntity['statementType'];
}

export interface INotificationList {
  items: INotification[];
  itemsSignatures?: INotificationSignatures[];
  count: number;
  countSignatures?: number;
}

export interface INotificationTopList {
  items: INotification[];
  itemsSignatures?: INotificationSignatures[];
}

export interface INotificationState {
  list: INotification[];
  notificationsSignaturesList: INotificationSignatures[];
  topList: INotificationTopList;
  listForRead: INotification[];
  totalCount: number;
  newCount: number;

  pagination: {
    pageNumber: number;
    pageSize: number;
  };
}

@Module({ dynamic: true, store, name: 'notifications' })
class Notifications extends VuexModule implements INotificationState {
  list = [];
  notificationsSignaturesList = [];
  topList: INotificationTopList = { items: [], itemsSignatures: [] };
  totalCount = 0;
  newCount = 0;
  listForRead = [];

  pagination = {
    pageNumber: 0,
    pageSize: 15,
  };

  @Mutation
  setList(payload: INotificationList) {
    // @ts-ignore
    this.list = payload.items;
    // @ts-ignore
    this.notificationsSignaturesList = payload.itemsSignatures;
  }

  @Mutation
  setTopList(payload: INotificationList) {
    // @ts-ignore
    this.topList = {
      // @ts-ignore
      items: payload.items,
      // @ts-ignore
      itemsSignatures: payload.itemsSignatures,
    };
  }

  @Mutation
  setTotalCount(val: number) {
    this.totalCount = val;
  }

  @Mutation
  setNewCount(val: number) {
    this.newCount = val;
    // console.log(this.newCount);
  }

  @Mutation
  setPageSize(payload: number) {
    this.pagination.pageSize = payload;
  }

  @Mutation
  setPageNumber(payload: number) {
    this.pagination.pageNumber = payload;
  }

  @Mutation
  setListForRead(payload: INotification[]) {
    // @ts-ignore
    this.listForRead = payload;
  }

  @Action
  addToListForRead(payload: INotification[]) {
    this.setListForRead(payload);
  }

  @Action
  clearListForRead() {
    this.setListForRead([]);
  }

  @Action
  changePageSize(payload: number) {
    this.setPageSize(payload);
  }

  @Action
  changePageNumber(payload: number) {
    this.setPageNumber(payload);
  }

  @Action
  async getUserNotifications() {
    const data = await getUserNotifications(
      this.pagination.pageNumber,
      this.pagination.pageSize
    );
    this.setList(data);
    this.setTotalCount(data.count);
  }

  @Action
  async getUserTopNotifications() {
    const data = await getUserTopNotifications();
    this.setTopList(data);
    this.setNewCount(data.count + data.countSignatures);
  }

  @Action
  async getCountNewUserNotifications() {
    const { count, countSignatures } = await getCountNewUserNotifications();
    this.setNewCount(count + countSignatures);
  }

  @Action
  async sendReadNotifications(data: any) {
    await sendReadNotifications(data);
    await this.getUserTopNotifications();
  }

  @Action
  async sendReadAllNotifications() {
    await markAllNotificationsRead();
    await this.getUserTopNotifications();
  }
}

export const NotificationModule = getModule(Notifications);
